import React,{useEffect} from "react";
import Helmet from "react-helmet";
import Header from "./header"
import Footer from "./footer"
import {useSelector,useDispatch} from "react-redux"
import {getclassfiction} from "../state/action"
import { useParams,Link } from "react-router-dom";
function Classfiction(){
  const  classfication  = useSelector((state) =>state.gemstone.classfication);
  let params = useParams();
 let classfictionId = params.id;
console.log(classfication)
const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getclassfiction(classfictionId))
  })
    return (
        <div>
        <Header/>
      <section className="page-title centred" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1621329109234-d7657d2f3846?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1548&q=80)'}}>
  <div className="auto-container">
    <div className="content-box">
      <div className="title">
        <h1>Classfiction</h1>
      </div>
      <ul className="bread-crumb clearfix">
        <li><Link to="/">Home</Link></li>
        
      </ul>
    </div>
  </div>
</section>

<section className="project-details">
  <div className="auto-container">
    <div className="project-details-content">
     
     {classfication[0]?.type.map((i)=>{
     return(
      <div className="two-column">
      <div className="row align-items-center clearfix">
        <div className="col-lg-5 col-md-6 col-sm-12 image-column">
          <figure className="image"><img style={{width:"250px",height:"150px"}}  src={i.image} alt /></figure>
        </div>
        <div className="col-lg-7 col-md-6 col-sm-12 text-column">
        <p><span style={{"font-weight":"bold","font-size":"20px","font_color":"black"}}>{i.name}</span> <br></br>{i.description}</p>
        </div>
      </div>
    </div>
     )
     })}
      
    </div>
  </div>
</section>

         <Footer/>
         <Helmet>
        <script src="assets/js/bootstrap.min.js"></script>
        <script src="assets/js/popper.min.js"></script>
        <script src="assets/js/owl.js"></script>
        <script src="assets/js/wow.js"></script>

        <script src="assets/js/scrollbar.js"></script>
        <script src="assets/js/appear.js"></script>
        <script src="assets/js/validation.js"></script>
        <script src="assets/js/jquery.js"></script>
        <script src="assets/js/jquery.fancybox.js"></script>

        <script defer="defer" src="assets/js/script.js"></script>
      </Helmet>
        </div>
    )
}
export default Classfiction;